<template>
  <Breadcrumb />
</template>
<script>
export default {
  name: "Usage",
  mounted() {
    this.$router.push({ name: "PageUnderConstruction" });
  },
};
</script>
